import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Modal } from "react-responsive-modal";
import { PopupInsideButton } from "../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { DropDownButton } from "../../../../../reusableComponents/dropDownButtonReusable/DropDownButton";
import { ReusableOnboardingButton } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { FilterTableManagement } from "./FilterTableManagment";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../../store/actions/errorActions";
import { update_new_subscription_for_vendor } from "../../../../../../store/actions/authAction";

import {
  change_table_status_table_management,
  vendor_seated_waittime_request,
} from "../../../../../../store/actions/dashboardAction/addingAction";
import { rsvp_assign_table_event_request } from "../../../../../../store/actions/RsvpEventDashboard/RsvpEventDashboardAction";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Alert from "react-s-alert";
import { tableImages } from "../../../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/TablesImages";

const TableManagementBodyRight = (props) => {
  const [openModel, setOpenModel] = useState(false);

  const onOpenModal = () => setOpenModel(true);
  const onCloseModal = () => setOpenModel(false);

  const [openFilter, setopenFilter] = useState(false);

  const [openFloor, setopenFloor] = useState(false);
  const [floors, setFloors] = useState([]);
  const [selectedFloor, setSelectedFloor] = useState({});

  const [openSection, setopenSection] = useState(false);

  const [tables, setTables] = useState([]);
  const [sections, setSections] = useState([]);
  const [selectedSections, setSelectedSections] = useState();
  const [seatingPrefs, setSeatingPref] = useState([]);

  const [selectedPref, setSelectedPref] = useState("");

  useEffect(() => {
    if (props.subscriptionData && props.subscriptionData.value) {
      setFloors(
        props.subscriptionData.table_setup &&
          props.subscriptionData.table_setup.floors &&
          props.subscriptionData.table_setup.floors
      );
      setSelectedFloor(
        props.subscriptionData.table_setup &&
          props.subscriptionData.table_setup.floors &&
          props.subscriptionData.table_setup.floors[0]
      );
      if (props.seating_area && props.seating_area.length > 0) {
        let areas = props.seating_area.filter(
          (ele) => ele.status === "APPROVED"
        );

        setSeatingPref(areas);
      }
    }
  }, []);
  useEffect(() => {
    let prefs = tables.filter((ele) => {
      console.log(ele.location, selectedPref);
      return ele.location === selectedPref;
    });
    console.log(prefs);
    setTables(prefs);
  }, [selectedPref]);
  useEffect(() => {
    if (props.subscriptionData && props.subscriptionData.value) {
      setSections([]);
      let tablesFloor = props.subscriptionData.table_setup.table.filter(
        (table) => {
          return table.floor_number === selectedFloor.floor_number;
        }
      );
      setTables(tablesFloor);
      if (selectedFloor && selectedFloor.area) {
        setSections([{ title: selectedFloor.area }]);
      }
      // console.log(selectedFloor.area);
    }
  }, [selectedFloor]);

  useEffect(() => {
    let tablesSection = tables.filter((table) => {
      return table.area === selectedSections;
    });
    setTables(tablesSection);
  }, [selectedSections]);
  const onChangeStatus = (formData) => {
    // console.log(formData);

    const token = props.auth.user.accessToken;
    const vendor_id = props.auth.user.VendorUser._id;

    props.change_table_status_table_management(
      props.subscription_id,
      formData.table_number,
      formData.status,
      token,
      vendor_id
    );
  };

  const onTransfer = (data) => {
    var allDinerDetails = props.dinerInfo;
    if (allDinerDetails && allDinerDetails.length > 0) {
      let diner = [];
      allDinerDetails.forEach((din) => {
        console.log(din.table_number, data.old_table_number);
        if (din.table_number === data.old_table_number) {
          diner.push(din);
        }
      });
      var dinerData = diner[0];
      if (dinerData && dinerData.table_number && data.pax_value) {
        if (dinerData.adult_count + dinerData.kids_count <= data.pax_value) {
          const token = props.auth.user.accessToken;
          const diner_id = dinerData._id;
          const vendor_id = props.auth.user.VendorUser._id;
          const formData = {
            table_number: data.new_table_number,
            diner_status: "SEATED",
            wait_time: parseInt(0),
            seatedTime: new Date().getTime(),
            vendor: vendor_id,
          };

          props.vendor_seated_waittime_request(
            formData,
            diner_id,
            vendor_id,
            token,
            onCallBackFunc
          );

          onChangeStatus({
            table_number: data.new_table_number,
            status: "OCCUPIED",
          });

          onChangeStatus({
            table_number: data.old_table_number,
            status: "AVAILABLE",
          });
        } else {
          console.log("Check the pax");
        }
      } else {
        console.log("No data found..!");
      }
      console.log(dinerData);
    } else {
      console.log("No data");
    }
  };
  const onTransferEventTable = (data) => {
    var allDinerDetails = props.dinerInfo;
    if (allDinerDetails && allDinerDetails.length > 0) {
      let diner = [];
      allDinerDetails.forEach((din) => {
        console.log(din.table_number, data.old_table_number);
        if (din.table_number === data.old_table_number) {
          diner.push(din);
        }
      });
      var dinerData = diner[0];
      if (dinerData && dinerData.table_number && data.pax_value) {
        if (dinerData.adult_count + dinerData.kids_count <= data.pax_value) {
          const token = props.auth.user.accessToken;
          const diner_id = dinerData._id;
          const vendor_id = props.auth.user.VendorUser._id;

          const formData = {
            vendor_id: vendor_id,
            event_id: props.getSingleEventInfo._id,
          };
          const waitTimeData = {
            event_status: "SEATED",
            wait_time: parseInt(0),
            table_number: data.new_table_number,
          };
          props.rsvp_assign_table_event_request(
            formData,
            waitTimeData,
            vendor_id,
            token,
            onCallBackFunc
          );

          onChangeStatus({
            table_number: data.new_table_number,
            status: "OCCUPIED",
          });

          onChangeStatus({
            table_number: data.old_table_number,
            status: "AVAILABLE",
          });
        } else {
          console.log("Check the pax");
        }
      } else {
        console.log("No data found..!");
      }
      console.log(dinerData);
    } else {
      console.log("No data");
    }
  };
  const onCallBackFunc = (e) => {
    return Alert.success(`<h4>Table assigned successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };
  return (
    <React.Fragment>
      <div className="container-fluid">
        <Row>
          <Col md={11}>
            <div className="d-flex">
              <div className="mt-4">
                <FilterTableManagement
                  displayText="Select Section"
                  status="1B"
                  open={openFilter}
                  onOpenModal={() => setopenFilter(true)}
                  displayDataMap={[
                    { title: "All" },
                    { title: "Occupied" },
                    { title: "Available" },
                    { title: "Dirty" },
                    { title: "On hold" },
                    { title: "Unavailable" },
                  ]}
                  onCloseModal={() => setopenFilter(false)}
                />
              </div>
              <div className="ml-3">
                {/* <button type="button" className="enIconBtn mr-3 btn btn-link">
                  <i
                    className="fa fa-upload"
                    style={{ color: "#000000" }}
                    aria-hidden="true"
                  ></i>
                </button> */}
                <ModelTableManagement
                  displayText="Select Floor"
                  open={openFloor}
                  floors={floors}
                  selected_id={
                    selectedFloor && selectedFloor._id && selectedFloor._id
                  }
                  status={
                    selectedFloor &&
                    selectedFloor.floor_number &&
                    selectedFloor.floor_number
                  }
                  onChange={(e) => {
                    setSelectedFloor(e);
                    setopenFloor(false);
                  }}
                  onOpenModal={() => setopenFloor(true)}
                  onCloseModal={() => setopenFloor(false)}
                />
              </div>
              <div className="ml-3">
                <ModelTableManagement
                  displayText="Select Section"
                  status={selectedSections}
                  open={openSection}
                  onChange={(e) => {
                    setSelectedSections(e);
                    setopenSection(false);
                  }}
                  onOpenModal={() => setopenSection(true)}
                  displayDataMap={sections}
                  onCloseModal={() => setopenSection(false)}
                />
              </div>
              <div className="ml-3">
                <ModelTableManagement
                  displayText="Seating Prefarence"
                  status={selectedPref}
                  open={openModel}
                  onOpenModal={onOpenModal}
                  displayDataMap={seatingPrefs}
                  onCloseModal={onCloseModal}
                  onChange={(e) => {
                    setSelectedPref(e);
                    onCloseModal(false);
                  }}
                />
              </div>
            </div>
          </Col>
          <Col md={1} align="right">
            <div className="mt-3" onClick={props.handleFullScreen}>
              <i className="fa fa-arrows-alt"></i>
            </div>
          </Col>
        </Row>
        <div className="mt-3">
          <GridsDisplay
            tables={tables}
            tableSelected={props.tableSelected}
            setTableSelected={
              props?.setTableSelected
                ? (data) => props.setTableSelected(data)
                : () => {}
            }
            fullScreen={props.fullScreen}
            onChangeStatus={onChangeStatus}
            handleFullScreen={props.handleFullScreen}
            onTransfer={onTransfer}
            origin={props.origin}
            onTransferEventTable={onTransferEventTable}
          />
        </div>
        <hr />
        <Container>
          <div className="d-flex justify-content-between">
            {tableTypes.map((data, index) => {
              return (
                <div className="d-flex" key={index}>
                  <div
                    style={{
                      backgroundColor: data.color,
                      height: "20px",
                      width: "20px",
                      borderRadius: "3px",
                    }}
                  ></div>
                  <div className="ml-2">{data.title}</div>
                </div>
              );
            })}
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

const GridsDisplay = (props) => {
  const [statusmodel, setChangeStatus] = useState(false);
  const [selected, setSelected] = useState({});
  const [transfer, setTransfer] = useState(false);
  const [from, setFrom] = useState({});
  const [to, setTo] = useState({});
  return (
    <>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          overflow: "hidden",
          overflowY: "scroll",
          maxHeight: props.fullScreen ? "25.66667vw" : "15.66667vw",
        }}
      >
        {props.tables &&
          props.tables.map((data, index) => {
            var tableImg =
              data.shape.toLowerCase() +
              "_" +
              data.status.toLowerCase() +
              "_" +
              data.pax_value.toString();
            // console.log();
            return (
              <div
                key={index}
                className={props.fullScreen ? `col-2 p-0` : `col-3 p-0`}
                align="center"
                style={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (data.status.toLowerCase() === "available") {
                    props.setTableSelected(data);
                  }
                  if (transfer && props.origin === "events") {
                    setTo(data);
                    props.onTransferEventTable({
                      new_table_number: data.table_number,
                      old_table_number: from.table_number,
                      pax_value: data.pax_value,
                    });

                    setTransfer(false);
                    props.handleFullScreen(false);
                  } else if (transfer) {
                    setTo(data);
                    props.onTransfer({
                      new_table_number: data.table_number,
                      old_table_number: from.table_number,
                      pax_value: data.pax_value,
                    });

                    setTransfer(false);
                    props.handleFullScreen(false);
                  } else {
                    setSelected(data);
                    setChangeStatus(true);
                    setFrom(data);
                  }
                }}
              >
                <div
                  className={`w-100 status-selected-button-box font_20_m ${
                    props.tableSelected &&
                    props.tableSelected._id === data._id &&
                    `sts_sld_btn_box_a`
                  }`}
                >
                  <div className="row justify-content-center">
                    <div
                      className={`${
                        props.fullScreen ? "col-7" : "col-12"
                      }  text-right`}
                    >
                      <img
                        src={tableImages[tableImg.split(" ").join("_")]}
                        alt="filter"
                        className="small-image img-fluid"
                      />
                      <span
                        className="f10-700"
                        style={{
                          position: "absolute",
                          bottom: "35%",
                          right: "38%",
                          textAlign: "center",
                          color: "#ffffff",
                        }}
                      >
                        {data.table_number}
                        <br />
                        {data.pax_value}px
                      </span>
                    </div>
                    {/* <div className={"col-7 text-left"}></div> */}
                  </div>
                </div>
              </div>
              // <div className="col-3" align="center">
              //   <PopupInsideButton
              //     buttonClass={
              //       props.status === "1"
              //         ? "status-selected-button-box font_20_m sts_sld_btn_box_a"
              //         : "status-selected-button-box font_20_m"
              //     }
              //     imgStyle={{ width: "25vh" }}
              //     buttonImage={tableImages.circle_dirty_1}
              //     buttonType="button"
              //     display={true}
              //     // onClick={onClickAll}
              //   />
              // </div>
            );
          })}
      </div>
      <TableStatus
        open={statusmodel}
        onCloseModal={setChangeStatus}
        tableData={selected}
        onChangeStatus={props.onChangeStatus}
        handleFullScreen={props.handleFullScreen}
        setTransfer={setTransfer}
      />
    </>
  );
};

export const TableStatus = (props) => {
  const [status, setStatus] = useState("");
  const handleChangeStatus = (e) => {
    e.preventDefault();
    if (status === "OCCUPIED") {
      props.handleFullScreen(true);
      props.setTransfer(true);
    } else {
      let formData = {
        table_number: props.tableData.table_number,
        status: status,
      };
      props.onChangeStatus(formData);
    }
    props.onCloseModal(false);
  };
  return (
    <React.Fragment>
      {/* Model */}
      <Dialog
        open={props.open}
        onClose={props.onCloseModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        closeButton
      >
        <DialogTitle id="alert-dialog-title">Table Status</DialogTitle>
        <DialogContent>
          <h4>Select one relevant option from below</h4>
          <div className="row" align="center" style={{ color: "#ffffff" }}>
            {tableStatuses.map((data, index) => {
              return (
                <React.Fragment key={index}>
                  {props.tableData.status === "Unavailable" ? (
                    <>
                      {data.value === "AVAILABLE" && (
                        <div
                          className={`col-3 p-2 m-2 ${
                            status === data.value && `sts_sld_btn_box_a`
                          }`}
                          style={{
                            backgroundColor: data.color,
                            borderRadius: "5px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setStatus(data.value);
                          }}
                        >
                          {data.title}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {" "}
                      <div
                        className={`col-3 p-2 m-2 ${
                          status === data.value && `sts_sld_btn_box_a`
                        }`}
                        style={{
                          backgroundColor: data.color,
                          borderRadius: "5px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setStatus(data.value);
                        }}
                      >
                        {data.title}
                      </div>{" "}
                    </>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </DialogContent>
        <DialogActions>
          <div class="d-flex align-items-center pt-4">
            <button
              type="button"
              class="btn-md mr-4 px-5 btn btn-outline-secondary"
              onClick={() => {
                props.onCloseModal(false);
                setStatus("");
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn-md px-5 btn btn-danger"
              onClick={handleChangeStatus}
            >
              Confirm
            </button>
          </div>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

const tableStatuses = [
  { title: "Available", color: "#1AB61E", value: "AVAILABLE" },
  { title: "Dirty", color: "#F08B23", value: "DIRTY" },
  { title: "Unavailable", color: "#AFAFAF", value: "UNAVAILABLE" },
  { title: "On Hold", color: "#FCB62B", value: "ON_HOLD" },
  { title: "Transfer", color: "#2196F3", value: "OCCUPIED" },
];

const tableTypes = [
  { title: "Occupied", color: "#F40C1A" },
  { title: "Available", color: "#1AB61E" },
  { title: "Dirty", color: "#B4782E" },
  { title: "On hold", color: "#FECD2F" },
  { title: "Unavailable", color: "#AFAFAF" },
];

const ModelTableManagement = ({
  status,
  onOpenModal,
  open,
  onCloseModal,
  seatingStatus,

  onClickAll,
  onClickWalkin,
  onClickSeated,
  onClickNonSeated,
  showText,
  showTextTwo,
  onChange,
  displayText,
  floors,
  onStatusClick,
  eventsMoreOptions,
  selected_id,
  displayDataMap,
}) => {
  const [selected, setSelect] = useState(status);
  const [newselected_id, setselected_id] = useState(selected_id);
  useEffect(() => {
    setSelect(status);
  }, [status]);
  return (
    <React.Fragment>
      <DropDownButton
        dropDownCss="main-dropdown-section"
        headingText={displayText}
        divClass="inside-div"
        insideText={status}
        displayDropDown=""
        onClick={onOpenModal}
      />
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customOverlay-request-accept-cancelled",
          modal: "small-popup",
          closeButton: "customCloseButton",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
      >
        <div className="reusable-popup-header-newstyle">
          <h4 className="c-black font_24_b">{displayText}</h4>
        </div>
        <div className="">
          <h4 className="font_22_m mt-5 mb-5">
            Select one relevant option from below
          </h4>
          {(displayText === "Select Section" ||
            displayText === "Seating Prefarence") && (
            <>
              <div className="row justify-content-start">
                {displayDataMap.map((data, index) => {
                  return (
                    <div className="col-4" key={index}>
                      <PopupInsideButton
                        buttonClass={
                          data.title === selected
                            ? "status-selected-button-box font_20_m sts_sld_btn_box_a"
                            : "status-selected-button-box font_20_m"
                        }
                        buttonText={data.title}
                        buttonType="button"
                        onClick={() => setSelect(data.title)}
                      />
                    </div>
                  );
                })}
              </div>
            </>
          )}
          {displayText === "Select Floor" && (
            <>
              <div className="row justify-content-start">
                {floors &&
                  floors.map((floors, index) => {
                    return (
                      <div className="col-4" key={index}>
                        <PopupInsideButton
                          buttonClass={
                            newselected_id === floors._id
                              ? "status-selected-button-box font_20_m sts_sld_btn_box_a"
                              : "status-selected-button-box font_20_m"
                          }
                          buttonText={floors.floor_number}
                          buttonType="button"
                          onClick={() => {
                            setSelect(floors);
                            setselected_id(floors._id);
                          }}
                        />
                      </div>
                    );
                  })}
              </div>
            </>
          )}
          <div className="mt-5 d-flex">
            <ReusableOnboardingButton
              buttonTitle="Cancel Button"
              buttonClass={
                "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              }
              buttonText="Cancel"
              onClick={onCloseModal}
              buttonType="button"
            />
            <ReusableOnboardingButton
              buttonTitle="Confirm Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              buttonText="Confirm"
              onClick={() => onChange(selected)}
              buttonType="button"
            />
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

TableManagementBodyRight.propTypes = {
  auth: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
  // subscriptionData: PropTypes.object.isRequired,
  // subscription_id: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  seating_area: state.category.seating_area,
  subscription: state.onboarding.onboard_subscription_details,
  subscriptionData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status
      .seating &&
    state.onboarding.onboard_subscription_details.casual_dining_status.seating
      .table_management,
  subscription_id:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details._id,
  getSingleEventInfo: state.rsvpEvent.get_single_event_info,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
  change_table_status_table_management,
  vendor_seated_waittime_request,

  rsvp_assign_table_event_request,
})(withRouter(TableManagementBodyRight));
